import Route from '@ember/routing/route';

export default class GoalsRoute extends Route {}
